const grades = {
  Twelve: 14,
  EEA: 32,
};

export default grades;
